import { Component, OnInit } from "@angular/core";
import { FacadeService } from "../../service/facade.service";

class ContactUsData {
  phone: string = "";
  facebook: string = "";
  email: string = "";
  location: string = "";
}

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  contactUsData: ContactUsData;

  constructor(private facadeService: FacadeService) {}

  ngOnInit() {
    this.facadeService.About.getContact(1).subscribe(contacts => {
      this.contactUsData = contacts.data;
    });
  }
}
